import { render, staticRenderFns } from "./breadcrumbsBlock.vue?vue&type=template&id=7fa831d6&scoped=true"
import script from "./breadcrumbsBlock.vue?vue&type=script&lang=js"
export * from "./breadcrumbsBlock.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbsBlock.vue?vue&type=style&index=0&id=7fa831d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa831d6",
  null
  
)

export default component.exports